import styled from "@emotion/styled"
import { useConsole } from "contexts/Console"
import getMediaQuery from "css/breakpoints"
import { fullGrid } from "css/grid"
import { body50, headline30 } from "css/text"
import { Fragment, useRef } from "react"

const Root = styled.section`
  ${fullGrid}
  padding-block: 10vh;
  row-gap: 8ex;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: main;
  row-gap: 2ex;
  text-wrap: pretty;
  z-index: 0;

  ${getMediaQuery("l")} {
    grid-column: col 4 / span 6;
  }

  h2 {
    ${headline30}
  }

  p {
    ${body50}
  }
`

const P = styled.p`
  font-weight: 700;
`

function Text({ title, chapo, paragraph }) {
  return (
    <Content>
      {title && <h2 dangerouslySetInnerHTML={{ __html: title }} />}
      {chapo && <P dangerouslySetInnerHTML={{ __html: chapo }} />}
      {paragraph?.map(t => (
        <p key={t} dangerouslySetInnerHTML={{ __html: t }} />
      ))}
    </Content>
  )
}

export default function ArticleSimple({ content = [] }) {
  const console = useConsole()
  const rroot = useRef()

  console.log("TestimoneeArticleSimple(%o)", content)

  return (
    <Root ref={rroot}>
      {content.map(item => (
        <Fragment key={item._metadata?.uid}>{item.text && <Text {...item.text} />}</Fragment>
      ))}
    </Root>
  )
}
